export default class Footer {
    constructor(element) {
        this.element = element;
        this.init();
    }

    init() {
        // On cible directement le <p class="large"> dans chaque has-submenu
        const triggers = this.element.querySelectorAll('.has-submenu p.large');
        triggers.forEach(trigger => {
            trigger.addEventListener('click', this.toggleSubmenu.bind(this));
        });
    }

    toggleSubmenu(event) {
        const submenuEl = event.currentTarget.parentElement; // le <li> parent

        // Ferme les autres sous-menus
        this.element.querySelectorAll('.has-submenu.submenu-active').forEach(el => {
            if (el !== submenuEl) {
                el.classList.remove('submenu-active');
            }
        });

        // Toggle sur le <li> cliqué
        submenuEl.classList.toggle('submenu-active');
    }
}
